import moment from "moment"
import { MultiSelectValue } from "./components/MultiSelect"
import i18n from "./i18n"
import { CONFIG } from "./services/ConfigService"

export const isoDate = moment().toISOString().substr(0, 10)
export const isoformat = "YYYY-MM-DD"
export const MAX_FILESIZE_MB = 150
export const MAX_FILESIZE_BYTES = 1024 * 1024 * MAX_FILESIZE_MB

export const ALLOWED_FILE_EXTENSIONS = ["pdf", "png", "jpeg", "jpg", "csv", "xlsx", "ods", "xml"]
export const ALLOWED_FILE_EXTENSIONS_ADDITIONAL = ["x31", "x81", "x86", "x87", "x89b"]


const mapOptionsToMultiselect = (options: MultiSelectValue[]): MultiSelectValue[] => {
    return options.map((entry: MultiSelectValue) => {
        const newEntry: MultiSelectValue = {
            label: i18n.t(entry.label),
            value: entry.value,
            hint: i18n.t(entry.hint || ""),
            keyLabel: entry.label,
            keyHint: entry.hint,
        }
        return newEntry
    })
}

export const getInvoiceType = (): MultiSelectValue[] => {
    const options = CONFIG?.invoiceType
    const result = options ? options : invoicetype
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getPaymentMeansOptions = (): MultiSelectValue[] => {
    const options = CONFIG?.paymentMeans?.options
    const result = options ? options : paymentmeans
    return mapOptionsToMultiselect(result)
}

export const getUnitsCodes = (): MultiSelectValue[] => {
    const options = CONFIG?.units
    const result = options ? options : units
    const mappedResult = mapOptionsToMultiselect(result)
    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getLaenderCodes = (): MultiSelectValue[] => {
    const mappedCodes = mapOptionsToMultiselect(LaenderCodes)

    const germanCode = mappedCodes.find((l) => l.value === "DE")
    const filteredCodes = mappedCodes.filter((l) => l.value !== germanCode?.value)
    if (!germanCode) {
        return mappedCodes.sort((a, b) => a.label.localeCompare(b.label))
    }

    return [germanCode, ...filteredCodes.sort((a, b) => a.label.localeCompare(b.label))]
}

export const getUmsatzsteuerOptions = (): MultiSelectValue[] => {
    const result = umsatzsteuerOptions
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getUmsatzsteuerCodesOptions = (): MultiSelectValue[] => {
    const result = umsatzsteuerCodesOptions
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getSteuerBerechnungsOptions = (): MultiSelectValue[] => {
    const result = steuerBerechnungsOptions
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getBT_158_1Options = (): MultiSelectValue[] => {
    const result = BT_158_1
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

export const getISO6523_BT157Options = (): MultiSelectValue[] => {
    const result = ISO6523_BT157
    const mappedResult = mapOptionsToMultiselect(result)

    return mappedResult.sort((a, b) => a.label.localeCompare(b.label))
}

const umsatzsteuerOptions: MultiSelectValue[] = [{ value: "19", label: "19 %" }]

const ISO6523_BT157: MultiSelectValue[] = [
    { value: "0197", label: "iso6523_bt157.197.label" },
    { value: "0173", label: "iso6523_bt157.173.label" },
    { value: "0160", label: "iso6523_bt157.160.label" },
    { value: "0209", label: "iso6523_bt157.209.label" },
]

const umsatzsteuerCodesOptions: MultiSelectValue[] = [
    { value: "S", label: "umsatzsteuercodes.S.label" },
    { value: "Z", label: "umsatzsteuercodes.Z.label" },
    { value: "E", label: "umsatzsteuercodes.E.label", hint: "umsatzsteuercodes.E.hint" },
    { value: "AE", label: "umsatzsteuercodes.AE.label", hint: "umsatzsteuercodes.AE.hint" },
    { value: "K", label: "umsatzsteuercodes.K.label", hint: "umsatzsteuercodes.K.hint" },
    { value: "G", label: "umsatzsteuercodes.G.label", hint: "umsatzsteuercodes.G.hint" },
    { value: "L", label: "umsatzsteuercodes.L.label" },
    { value: "M", label: "umsatzsteuercodes.M.label" },
]

const steuerBerechnungsOptions: MultiSelectValue[] = [
    { value: "P", label: "steuerBerechnung.P.label" },
    { value: "G", label: "steuerBerechnung.G.label" },
]

const BT_158_1: MultiSelectValue[] = [
    { value: "ZZZ", label: "bt_158_1.ZZZ.label" },
    { value: "BH", label: "bt_158_1.BH.label" },
    { value: "BB", label: "bt_158_1.BB.label" },
    { value: "SSW", label: "bt_158_1.SSW.label" },
    { value: "SRV", label: "bt_158_1.SRV.label" },
    { value: "SUF", label: "bt_158_1.SUF.label" },
    { value: "EN", label: "bt_158_1.EN.label" },
    { value: "AA", label: "bt_158_1.AA.label" },
    { value: "AJ", label: "bt_158_1.AJ.label" },
]

const LaenderCodes: MultiSelectValue[] = [
    { value: "AF", label: "countries.AF.label" },
    { value: "EG", label: "countries.EG.label" },
    { value: "AX", label: "countries.AX.label" },
    { value: "AL", label: "countries.AL.label" },
    { value: "DZ", label: "countries.DZ.label" },
    { value: "VI", label: "countries.VI.label" },
    { value: "UM", label: "countries.UM.label" },
    { value: "AS", label: "countries.AS.label" },
    { value: "AD", label: "countries.AD.label" },
    { value: "AO", label: "countries.AO.label" },
    { value: "AI", label: "countries.AI.label" },
    { value: "AQ", label: "countries.AQ.label" },
    { value: "AG", label: "countries.AG.label" },
    { value: "GQ", label: "countries.GQ.label" },
    { value: "SY", label: "countries.SY.label" },
    { value: "AR", label: "countries.AR.label" },
    { value: "AM", label: "countries.AM.label" },
    { value: "AW", label: "countries.AW.label" },
    { value: "AZ", label: "countries.AZ.label" },
    { value: "ET", label: "countries.ET.label" },
    { value: "AU", label: "countries.AU.label" },
    { value: "BS", label: "countries.BS.label" },
    { value: "BH", label: "countries.BH.label" },
    { value: "BD", label: "countries.BD.label" },
    { value: "BB", label: "countries.BB.label" },
    { value: "BE", label: "countries.BE.label" },
    { value: "BZ", label: "countries.BZ.label" },
    { value: "BJ", label: "countries.BJ.label" },
    { value: "BM", label: "countries.BM.label" },
    { value: "BT", label: "countries.BT.label" },
    { value: "VE", label: "countries.VE.label" },
    { value: "BQ", label: "countries.BQ.label" },
    { value: "BA", label: "countries.BA.label" },
    { value: "BW", label: "countries.BW.label" },
    { value: "BV", label: "countries.BV.label" },
    { value: "BR", label: "countries.BR.label" },
    { value: "VG", label: "countries.VG.label" },
    { value: "IO", label: "countries.IO.label" },
    { value: "BN", label: "countries.BN.label" },
    { value: "BG", label: "countries.BG.label" },
    { value: "BF", label: "countries.BF.label" },
    { value: "BI", label: "countries.BI.label" },
    { value: "CV", label: "countries.CV.label" },
    { value: "CL", label: "countries.CL.label" },
    { value: "CN", label: "countries.CN.label" },
    { value: "CK", label: "countries.CK.label" },
    { value: "CR", label: "countries.CR.label" },
    { value: "CI", label: "countries.CI.label" },
    { value: "CW", label: "countries.CW.label" },
    { value: "DK", label: "countries.DK.label" },
    { value: "CD", label: "countries.CD.label" },
    { value: "KP", label: "countries.KP.label" },
    { value: "LA", label: "countries.LA.label" },
    { value: "DE", label: "countries.DE.label" },
    { value: "DM", label: "countries.DM.label" },
    { value: "DO", label: "countries.DO.label" },
    { value: "DJ", label: "countries.DJ.label" },
    { value: "EC", label: "countries.EC.label" },
    { value: "MK", label: "countries.MK.label" },
    { value: "SV", label: "countries.SV.label" },
    { value: "ER", label: "countries.ER.label" },
    { value: "EE", label: "countries.EE.label" },
    { value: "FK", label: "countries.FK.label" },
    { value: "FO", label: "countries.FO.label" },
    { value: "FJ", label: "countries.FJ.label" },
    { value: "FI", label: "countries.FI.label" },
    { value: "FM", label: "countries.FM.label" },
    { value: "FR", label: "countries.FR.label" },
    { value: "TF", label: "countries.TF.label" },
    { value: "GF", label: "countries.GF.label" },
    { value: "PF", label: "countries.PF.label" },
    { value: "GA", label: "countries.GA.label" },
    { value: "GM", label: "countries.GM.label" },
    { value: "GE", label: "countries.GE.label" },
    { value: "GH", label: "countries.GH.label" },
    { value: "GI", label: "countries.GI.label" },
    { value: "GD", label: "countries.GD.label" },
    { value: "GR", label: "countries.GR.label" },
    { value: "GL", label: "countries.GL.label" },
    { value: "GP", label: "countries.GP.label" },
    { value: "GU", label: "countries.GU.label" },
    { value: "GT", label: "countries.GT.label" },
    { value: "GG", label: "countries.GG.label" },
    { value: "GN", label: "countries.GN.label" },
    { value: "GW", label: "countries.GW.label" },
    { value: "GY", label: "countries.GY.label" },
    { value: "HT", label: "countries.HT.label" },
    { value: "HM", label: "countries.HM.label" },
    { value: "HN", label: "countries.HN.label" },
    { value: "HK", label: "countries.HK.label" },
    { value: "IN", label: "countries.IN.label" },
    { value: "ID", label: "countries.ID.label" },
    { value: "IM", label: "countries.IM.label" },
    { value: "IQ", label: "countries.IQ.label" },
    { value: "IE", label: "countries.IE.label" },
    { value: "IR", label: "countries.IR.label" },
    { value: "IS", label: "countries.IS.label" },
    { value: "IL", label: "countries.IL.label" },
    { value: "IT", label: "countries.IT.label" },
    { value: "JM", label: "countries.JM.label" },
    { value: "JP", label: "countries.JP.label" },
    { value: "YE", label: "countries.YE.label" },
    { value: "JE", label: "countries.JE.label" },
    { value: "JO", label: "countries.JO.label" },
    { value: "KY", label: "countries.KY.label" },
    { value: "KH", label: "countries.KH.label" },
    { value: "CM", label: "countries.CM.label" },
    { value: "CA", label: "countries.CA.label" },
    { value: "KZ", label: "countries.KZ.label" },
    { value: "QA", label: "countries.QA.label" },
    { value: "KE", label: "countries.KE.label" },
    { value: "KG", label: "countries.KG.label" },
    { value: "KI", label: "countries.KI.label" },
    { value: "CC", label: "countries.CC.label" },
    { value: "CO", label: "countries.CO.label" },
    { value: "KM", label: "countries.KM.label" },
    { value: "CG", label: "countries.CG.label" },
    { value: "HR", label: "countries.HR.label" },
    { value: "CU", label: "countries.CU.label" },
    { value: "KW", label: "countries.KW.label" },
    { value: "LS", label: "countries.LS.label" },
    { value: "LV", label: "countries.LV.label" },
    { value: "LB", label: "countries.LB.label" },
    { value: "LR", label: "countries.LR.label" },
    { value: "LY", label: "countries.LY.label" },
    { value: "LI", label: "countries.LI.label" },
    { value: "LT", label: "countries.LT.label" },
    { value: "LU", label: "countries.LU.label" },
    { value: "MO", label: "countries.MO.label" },
    { value: "MG", label: "countries.MG.label" },
    { value: "MW", label: "countries.MW.label" },
    { value: "MY", label: "countries.MY.label" },
    { value: "MV", label: "countries.MV.label" },
    { value: "ML", label: "countries.ML.label" },
    { value: "MT", label: "countries.MT.label" },
    { value: "MP", label: "countries.MP.label" },
    { value: "MA", label: "countries.MA.label" },
    { value: "MH", label: "countries.MH.label" },
    { value: "MQ", label: "countries.MQ.label" },
    { value: "MR", label: "countries.MR.label" },
    { value: "MU", label: "countries.MU.label" },
    { value: "YT", label: "countries.YT.label" },
    { value: "MX", label: "countries.MX.label" },
    { value: "MC", label: "countries.MC.label" },
    { value: "MN", label: "countries.MN.label" },
    { value: "MS", label: "countries.MS.label" },
    { value: "ME", label: "countries.ME.label" },
    { value: "MZ", label: "countries.MZ.label" },
    { value: "MM", label: "countries.MM.label" },
    { value: "NA", label: "countries.NA.label" },
    { value: "NR", label: "countries.NR.label" },
    { value: "NP", label: "countries.NP.label" },
    { value: "NC", label: "countries.NC.label" },
    { value: "NZ", label: "countries.NZ.label" },
    { value: "NI", label: "countries.NI.label" },
    { value: "NL", label: "countries.NL.label" },
    { value: "NE", label: "countries.NE.label" },
    { value: "NG", label: "countries.NG.label" },
    { value: "NU", label: "countries.NU.label" },
    { value: "NF", label: "countries.NF.label" },
    { value: "NO", label: "countries.NO.label" },
    { value: "OM", label: "countries.OM.label" },
    { value: "AT", label: "countries.AT.label" },
    { value: "PK", label: "countries.PK.label" },
    { value: "PW", label: "countries.PW.label" },
    { value: "PS", label: "countries.PS.label" },
    { value: "PA", label: "countries.PA.label" },
    { value: "PG", label: "countries.PG.label" },
    { value: "PY", label: "countries.PY.label" },
    { value: "PE", label: "countries.PE.label" },
    { value: "PH", label: "countries.PH.label" },
    { value: "PN", label: "countries.PN.label" },
    { value: "BO", label: "countries.BO.label" },
    { value: "PL", label: "countries.PL.label" },
    { value: "PT", label: "countries.PT.label" },
    { value: "PR", label: "countries.PR.label" },
    { value: "KR", label: "countries.KR.label" },
    { value: "MD", label: "countries.MD.label" },
    { value: "RE", label: "countries.RE.label" },
    { value: "RW", label: "countries.RW.label" },
    { value: "RO", label: "countries.RO.label" },
    { value: "RU", label: "countries.RU.label" },
    { value: "SB", label: "countries.SB.label" },
    { value: "ZM", label: "countries.ZM.label" },
    { value: "WS", label: "countries.WS.label" },
    { value: "SM", label: "countries.SM.label" },
    { value: "ST", label: "countries.ST.label" },
    { value: "SA", label: "countries.SA.label" },
    { value: "SE", label: "countries.SE.label" },
    { value: "CH", label: "countries.CH.label" },
    { value: "SN", label: "countries.SN.label" },
    { value: "RS", label: "countries.RS.label" },
    { value: "SC", label: "countries.SC.label" },
    { value: "SL", label: "countries.SL.label" },
    { value: "ZW", label: "countries.ZW.label" },
    { value: "SG", label: "countries.SG.label" },
    { value: "SK", label: "countries.SK.label" },
    { value: "SI", label: "countries.SI.label" },
    { value: "SO", label: "countries.SO.label" },
    { value: "ES", label: "countries.ES.label" },
    { value: "LK", label: "countries.LK.label" },
    { value: "BL", label: "countries.BL.label" },
    { value: "SH", label: "countries.SH.label" },
    { value: "KN", label: "countries.KN.label" },
    { value: "LC", label: "countries.LC.label" },
    { value: "MF", label: "countries.MF.label" },
    { value: "SX", label: "countries.SX.label" },
    { value: "PM", label: "countries.PM.label" },
    { value: "VC", label: "countries.VC.label" },
    { value: "ZA", label: "countries.ZA.label" },
    { value: "SD", label: "countries.SD.label" },
    { value: "GS", label: "countries.GS.label" },
    { value: "SS", label: "countries.SS.label" },
    { value: "SR", label: "countries.SR.label" },
    { value: "SJ", label: "countries.SJ.label" },
    { value: "SZ", label: "countries.SZ.label" },
    { value: "TJ", label: "countries.TJ.label" },
    { value: "TW", label: "countries.TW.label" },
    { value: "TH", label: "countries.TH.label" },
    { value: "TL", label: "countries.TL.label" },
    { value: "TG", label: "countries.TG.label" },
    { value: "TK", label: "countries.TK.label" },
    { value: "TO", label: "countries.TO.label" },
    { value: "TT", label: "countries.TT.label" },
    { value: "TD", label: "countries.TD.label" },
    { value: "CZ", label: "countries.CZ.label" },
    { value: "TN", label: "countries.TN.label" },
    { value: "TR", label: "countries.TR.label" },
    { value: "TM", label: "countries.TM.label" },
    { value: "TC", label: "countries.TC.label" },
    { value: "TV", label: "countries.TV.label" },
    { value: "UG", label: "countries.UG.label" },
    { value: "UA", label: "countries.UA.label" },
    { value: "HU", label: "countries.HU.label" },
    { value: "UY", label: "countries.UY.label" },
    { value: "UZ", label: "countries.UZ.label" },
    { value: "VU", label: "countries.VU.label" },
    { value: "VA", label: "countries.VA.label" },
    { value: "AE", label: "countries.AE.label" },
    { value: "TZ", label: "countries.TZ.label" },
    { value: "US", label: "countries.US.label" },
    { value: "GB", label: "countries.GB.label" },
    { value: "VN", label: "countries.VN.label" },
    { value: "WF", label: "countries.WF.label" },
    { value: "CX", label: "countries.CX.label" },
    { value: "BY", label: "countries.BY.label" },
    { value: "EH", label: "countries.EH.label" },
    { value: "CF", label: "countries.CF.label" },
    { value: "CY", label: "countries.CY.label" },
]

const units: MultiSelectValue[] = [
    { value: "C62", label: "units.C62.label" },
    { value: "BLL", label: "units.BLL.label" },
    { value: "GWH", label: "units.GWH.label" },
    { value: "GRM", label: "units.GRM.label" },
    { value: "1I", label: "units.1I.label" },
    { value: "KGM", label: "units.KGM.label" },
    { value: "KMT", label: "units.KMT.label" },
    { value: "KWH", label: "units.KWH.label" },
    { value: "MTQ", label: "units.MTQ.label" },
    { value: "LTR", label: "units.LTR.label" },
    { value: "MTR", label: "units.MTR.label" },
    { value: "P1", label: "units.P1.label" },
    { value: "HUR", label: "units.HUR.label" },
    { value: "CTN", label: "units.CTN.label" },
    { value: "DT", label: "units.DT.label" },
    { value: "CMT", label: "units.CMT.label" },
    { value: "INH", label: "units.INH.label" },
]

const paymentmeans: MultiSelectValue[] = [
    { value: "10", label: "paymentmeans.10.label" },
    { value: "58", label: "paymentmeans.58.label" },
    { value: "59", label: "paymentmeans.59.label" },
]

const invoicetype: MultiSelectValue[] = [
    { value: "326", label: "invoicetypes.326.label" },
    { value: "380", label: "invoicetypes.380.label" },
    { value: "384", label: "invoicetypes.384.label" },
    { value: "389", label: "invoicetypes.389.label" },
    { value: "381", label: "invoicetypes.381.label" },
    { value: "875", label: "invoicetypes.875.label" },
    { value: "876", label: "invoicetypes.876.label" },
    { value: "877", label: "invoicetypes.877.label" },
]
